/**
 * Created by Alex Aguilar on 5/3/2016.
 */
(function () {
    'use strict';

    angular.module('seatMap', [])
        .directive('seatMapContainer', seatMapContainer)
        .directive('seatDraggabilly', seatDraggabilly)
        .directive('seatMapSection', seatMapSection)
        .directive('addCategory',['$uibModal', addCategory])
        .directive('setNameToSeat',['$uibModal', '$compile', setNameToSeat])
        .directive('showHideFile', showHideFile)
        .directive('dragResizeCategory', dragResizeCategory)
        .directive('resizeTemplate', resizeTemplate)
        .directive('showHideFloor', showHideFloor)

    function seatMapContainer() {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            /*element.draggabilly({
                containment: true
            });*/
        }
    }

    function seatDraggabilly() {
        var directive = {
            restrict: 'AC',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var $draggable = element.draggabilly({
                containment: true,
                grid: [5, 5]
            });
            var draggie = $draggable.data('draggabilly');
            $draggable.on( 'dragMove', function() {
                scope.setTopLeftPositionToSeat(attrs.cabin,attrs.seat,draggie.position.y, draggie.position.x, attrs.floor);
            });
        }
    }

    function seatMapSection(){
        var directive = {
            restrict: 'AC',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var sectionTarget = attrs.sectionTarget,
                sectionTabSize = $('#' + sectionTarget + ' .section-map-tab').length,
                sectionNameTab = attrs.sectionName;

            var scrollLeft, setAttrButton, buttonDisabled, buttonEnable;

            $('.span-section-map').on('click', function(event){
                var elementJQuery = $(element),
                    jQuerySpan = $(this),
                    action = jQuerySpan.data('action');

                var sectionNext = elementJQuery.data("next"),
                    sectionPrevious = elementJQuery.data("previous"),
                    btnPrevious = elementJQuery.find('[data-action="previous"]').first(),
                    btnNext = elementJQuery.find('[data-action="next"]').last(),
                    sectionName = "";

                switch (action){
                    case "previous":
                        sectionName = $('#' + sectionNameTab + sectionPrevious);
                        scrollLeft(sectionName);
                        setAttrButton((parseInt(sectionPrevious)-1), (parseInt(sectionPrevious)+1), btnNext, btnPrevious);
                        event.preventDefault();
                        break;
                    case "next":
                        sectionName = $('#' + sectionNameTab + sectionNext);
                        scrollLeft(sectionName);
                        setAttrButton((parseInt(sectionNext)-1), (parseInt(sectionNext)+1), btnNext, btnPrevious);
                        event.preventDefault();
                        break;
                }
            });

            scrollLeft = function(sectionJQ){
                $('#' + sectionTarget).stop().animate({
                    scrollLeft: sectionJQ.offset().left - (255 + 60)
                }, 1000);
            }

            setAttrButton = function(previous, next, btnNext, btnPrevious){

                if(previous == 0){
                    buttonDisabled(btnPrevious);
                }else{
                    buttonEnable(btnPrevious)
                }

                if(next <= sectionTabSize){
                    buttonEnable(btnNext);
                }else{
                    buttonDisabled(btnNext);
                }

                element.data('next', next);
                element.data('previous', previous);
            }

            buttonDisabled = function(button){
                button.addClass("disabled");
                button.attr("disabled", "disabled");
            }

            buttonEnable = function(button){
                button.removeClass("disabled");
                button.removeAttr("disabled");
            }
        }
    }

    function addCategory($uibModal) {

        var directive = {
            restrict: 'AC',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            element.on('click', function(){
                var modalInstance = $uibModal.open({
                    templateUrl: 'app/admin/configGeneral/aircraft/seatMap/modalAddCabin.html',
                    controller: 'modalCabinCtrl',
                    size: 'sm',
                    close: true
                });

                modalInstance.result.then(function (cabin) {
                    if(!scope.existsCabins(cabin,(attrs.floor-1))) {
                        scope.formSeatMap.floors[attrs.floor-1].labelCabinFloor = 'tiene cabina';
                        scope.step2.labelMissingCabin = "todos tienen cabina";
                        for(var i=0; i<scope.formSeatMap.floors.length; i++){
                            if(scope.formSeatMap.floors[i].labelCabinFloor == ""){
                                scope.step2.labelMissingCabin = "";
                                break;
                            }
                        }

                        var container = $('#mainContainerFloor'+attrs.floor);
                        var container2 = $('#mainContainer2Floor'+attrs.floor);
                        var container3 = $('#mainContainer3Floor'+attrs.floor);
                        var tabContainerWidth = $('.tab-pane-seat-map').width();
                        var tabContainerLeft = tabContainerWidth/2;

                        container.width($('#imgMapBaseFloor'+attrs.floor).width());
                        container.height($('#imgMapBaseFloor'+attrs.floor).height());

                        container2.width($('#imgMapBaseFloor'+attrs.floor).width());
                        container2.height($('#imgMapBaseFloor'+attrs.floor).height());

                        container3.width($('#imgMapBaseFloor'+attrs.floor).width());
                        container3.height($('#imgMapBaseFloor'+attrs.floor).height());

                        scope.formSeatMap.floors[attrs.floor-1].cabins.push({
                            "category": cabin.categoryId,
                            "floor": attrs.floor,
                            "height": 150,
                            "left": tabContainerLeft,
                            "name": cabin.name,
                            "top": 10,
                            "width": 150,
                            'seats':[]
                        });
                    }else{
                        scope.viewError();
                    }
                }, function () {
                });
            });
        }
    }

    function setNameToSeat($uibModal,$compile) {

        var directive = {
            restrict: 'AC',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            element.on('click', function(){
                var number=attrs.seatNumber;
                var hasPlug = attrs.seatHasPlug;
                var modalInstance = $uibModal.open({
                    templateUrl: 'app/admin/configGeneral/aircraft/seatMap/modalAddNameSeat.html',
                    controller: 'modalCabinSeatNameCtrl',
                    size: 'sm',
                    close: true,
                    resolve:{
                        'number':[function(){
                            return number;
                        }],
                        'hasPlug':[function(){
                            return hasPlug
                        }]
                    }
                });

                modalInstance.result.then(function (name) {
                    name = (name.trim()).toUpperCase();
                    if(!thereIsThisNumber(scope,name,attrs.floor,attrs.cabinid,attrs.seatid)) {
                        scope.formSeatMap.floors[attrs.floor - 1].cabins[attrs.cabinid].seats[attrs.seatid].number = name;
                    }else{
                        scope.viewError();
                    }
                }, function () {
                });
            });
        }

        function thereIsThisNumber(scope,name,floor,cabinid,seatid){
            for(var i=0; i<scope.formSeatMap.floors[floor-1].cabins[cabinid].seats.length; i++){
                if(i != seatid){
                    if(scope.formSeatMap.floors[floor-1].cabins[cabinid].seats[i].number == name){
                        return true;
                    }
                }
            }
            return false;
        }
    }

    function showHideFile() {
        var directive = {
            restrict: 'AC',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var content = $('#mapFileFloor2');
            content.hide();
            element.on('click keyup',function(){
                if(scope.formSeatMap.numberGround == 2){
                    content.show();
                    scope.validateFloor2=true;
                    if(scope.formSeatMap.floors.length<2){
                        scope.borrarFile();
                        scope.formSeatMap.floors.splice(1,1);
                        scope.formSeatMap.floors.push({
                            'number': 2
                            ,'template': ''
                            ,'labelCabinFloor': ''
                            ,'cabins' : []
                        });
                    }
                }else{
                    content.hide();
                    scope.validateFloor2=false;
                    scope.borrarFile();
                    scope.formSeatMap.floors.splice(1,1);
                    if(scope.step1.map2 != undefined) {
                        scope.step1.map2 = undefined;
                    }
                }
            })
        }
    }

    function dragResizeCategory() {

        var directive = {
            restrict: 'AC',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element,attrs) {

            var $dragResize = element.draggable({
                containment: "#mainContainerFloor"+attrs.dragResizeCategory,
                grid: [5, 5]
            }).resizable({
                containment: "#mainContainerFloor"+attrs.dragResizeCategory,
                grid: [5, 5]
            });

            $dragResize.on( "resizestop", function( event, ui ) {
                var pos = scope.getIndexCabin(attrs.dragdataKey,(attrs.dragResizeCategory-1));
                scope.formSeatMap.floors[attrs.dragResizeCategory-1].cabins[pos].width = ui.size.width;
                scope.formSeatMap.floors[attrs.dragResizeCategory-1].cabins[pos].height = ui.size.height;
            });
            $dragResize.on( "dragstop", function( event, ui ) {
                var pos = scope.getIndexCabin(attrs.dragdataKey,(attrs.dragResizeCategory-1));
                scope.formSeatMap.floors[attrs.dragResizeCategory-1].cabins[pos].left = ui.position.left;
                scope.formSeatMap.floors[attrs.dragResizeCategory-1].cabins[pos].top = ui.position.top;
            });
        }
    }

    function resizeTemplate() {

        var directive = {
            restrict: 'AC',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope,element) {
            element.on('click', function(){
                if(scope.formSeatMap.numberGround != undefined){

                    if(scope.formSeatMap.numberGround==1) {
                        $('#wizard2_1').show();
                        $('#wizard3_1').show();
                        $('#wizard4_1').show();
                    }else{
                        $('#wizard2_1').show();
                        $('#wizard3_1').show();
                        $('#wizard4_1').show();

                        $('#wizard2_2').hide();
                        $('#wizard3_2').hide();
                        $('#wizard4_2').hide();
                    }

                    for(var i=0; i<scope.formSeatMap.floors.length;i++){
                        if(scope.formSeatMap.floors[i].template != "") {
                            var container = $('#mainContainerFloor' + (i + 1));
                            var container2 = $('#mainContainer2Floor' + (i + 1));
                            var container3 = $('#mainContainer3Floor' + (i + 1));

                            container.width($('#imgMapBaseFloor' + (i + 1))[0].width);
                            container.height($('#imgMapBaseFloor' + (i + 1))[0].height);

                            container2.width($('#imgMapBaseFloor' + (i + 1))[0].width);
                            container2.height($('#imgMapBaseFloor' + (i + 1))[0].height);

                            container3.width($('#imgMapBaseFloor' + (i + 1))[0].width);
                            container3.height($('#imgMapBaseFloor' + (i + 1))[0].height);
                        }
                    }
                }
            });
        }
    }

    function showHideFloor() {
        var directive = {
            restrict: 'AC',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            element.on('click',function(){
                if(attrs.floor == 1){
                    for(var i=2; i<5; i++){
                        $("#wizard"+i+"_2").hide();
                        $("#wizard"+i+"_1").show();
                        //$('#firstFloorW'+i)[0].checked = true;
                    }
                }else{
                    for(var i=2; i<5; i++){
                        $("#wizard"+i+"_1").hide();
                        $("#wizard"+i+"_2").show();
                        //$('#secondFloorW'+i)[0].checked = true;
                    }
                }
            })
        }
    }
})();
